import React from 'react'
import { BiSolidQuoteAltLeft } from "react-icons/bi";
import { BiSolidQuoteAltRight } from "react-icons/bi";

function Reviewdata({ para1, para2, para3, para4, user }) {
  return (
    <div className='content'>
      <BiSolidQuoteAltLeft className='iconquote' />
      <p>{para1}</p>
      <p>{para2}</p>
      <p>{para3}</p>
      <p>{para4}</p>
      <div className='last-line d-flex justify-content-between align-items-center'>
        <p>{user}</p>
        <BiSolidQuoteAltRight className='iconquote' />
      </div>
    </div>
  )
}

export default Reviewdata
